import * as React from 'react'
import Spinner from './Spinner'

const Loading = () => (
  <div className="sp-flex sp-fixed sp-bottom-8 sp-right-10 sp-text-survey-text-ai sp-bg-survey-background sp-shadow-survey-shadow p-0.5 sp-rounded-[50%]">
    <Spinner />
  </div>
)

export default Loading
